import React from 'react';
import { Stack, IconButton, Tooltip } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import TimelineIcon from '@mui/icons-material/Timeline';
import ScheduleIcon from '@mui/icons-material/Schedule';
import DescriptionIcon from '@mui/icons-material/Description';

export default function CrmQuickActions({
  onAddContact, onAddDeal, onAddTask, onAddNote,
}) {
  return (
    <Stack direction="row" spacing={1} sx={{ mb: 3 }}>
      <Tooltip title="Add Contact">
        <IconButton
          color="primary"
          onClick={onAddContact}
          sx={{
            bgcolor: 'primary.main',
            color: 'white',
            '&:hover': { bgcolor: 'primary.dark' },
          }}
        >
          <PeopleIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Add Deal">
        <IconButton
          color="success"
          onClick={onAddDeal}
          sx={{
            bgcolor: 'success.main',
            color: 'white',
            '&:hover': { bgcolor: 'success.dark' },
          }}
        >
          <TimelineIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Add Task">
        <IconButton
          color="info"
          onClick={onAddTask}
          sx={{
            bgcolor: 'info.main',
            color: 'white',
            '&:hover': { bgcolor: 'info.dark' },
          }}
        >
          <ScheduleIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Add Note">
        <IconButton
          color="secondary"
          onClick={onAddNote}
          sx={{
            bgcolor: 'secondary.main',
            color: 'white',
            '&:hover': { bgcolor: 'secondary.dark' },
          }}
        >
          <DescriptionIcon />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
